import {INFO_BACKGROUND} from "../../../../../themes/themeConfigurator";
import {scrollStyles} from "../../../../Modelportfolios/List/styles";

const styles = (theme) => ({
  container: {
     height: 'var(--main-page-height)',
  },
  sideMenu: {
    minWidth: 250,
    borderRight: '1px solid #E2E8F0',
    paddingTop: theme.spacing(3),

    [theme.breakpoints.down('md')]: {
      minWidth: 180,
    },

    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(1),
      minWidth: 'auto',
      width: '100%'
    }
  },
  listItemRoot: {
    color: 'initial',
    fontFamily: 'Roboto-Regular !important',
    [theme.breakpoints.up('sm')]: {
      paddingTop: '10px !important',
      paddingBottom: '10px !important'
    }
  },
  listItemRootNested: {
    paddingLeft: theme.spacing(4),
  },
  listItemSelected: {
    fontFamily: 'Roboto-Bold !important',
    backgroundColor: `${INFO_BACKGROUND} !important`,
  },
  mainPage: {
    margin: theme.spacing(1),
    paddingRight: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(3),
      paddingRight: theme.spacing(3),
      height: 'calc(var(--main-page-height, calc(100svh - 132px)) - 48px)',
      overflow: 'auto',
      ...scrollStyles,
    },
    [theme.breakpoints.only('xs')]: {
      margin: 0,
      padding: theme.spacing(3), // container spacing={3} produce negative margin which makes scroll on xs
    },

    marginRight: 0,
  }
});

export default styles;